import { z } from 'zod'

export const MembershipSchema = z.object({
  balance: z.coerce.number(),
})
